import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=21a0e63f&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=21a0e63f&prod&lang=scss&scoped=true&"
import style1 from "./Notification.vue?vue&type=style&index=1&id=21a0e63f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a0e63f",
  null
  
)

export default component.exports